import React from 'react';
import { useTranslation } from 'react-i18next';

import { ViewSettings } from '../../../../../../viewer/view-settings';
import { SkyviewContext } from '../../../../skyview/skyview-state';
import { WrapWithSettingsIcon } from '../../settings/wrap-with-settings-icon';
import { ToolIcon } from '../../tool-icon';
import { useViewSettings } from '../view-settings/use-view-settings';
import { PointCloudSettings } from './point-cloud-settings';

type Props = {
  toolbarRef: React.RefObject<HTMLElement>;
  /** False when the settings are in the view settings instead. */
  withSettings?: boolean;
};

const PointCloudTool = (props: Props) => {
  const { t } = useTranslation();
  const { skyview } = React.useContext(SkyviewContext);
  useViewSettings();

  const isPointCloudSceneActive = skyview.isClassicViewActive('pointCloud');
  const isPointCloudSceneAvailable = skyview.isPointCloudSceneAvailable();

  const toolIcon = (
    <ToolIcon
      active={isPointCloudSceneActive}
      callback={() => ViewSettings.instance.showClassicView('pointCloud')}
      disabled={!isPointCloudSceneAvailable}
      icon={['fal', 'cloud']}
      tooltip={{
        title: t('pointcloud.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('pointcloud.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );

  if (props.withSettings === false) {
    return toolIcon;
  }

  return (
    <WrapWithSettingsIcon
      content={<PointCloudSettings />}
      disabled={!isPointCloudSceneActive}
      toolbarRef={props.toolbarRef}
      tooltip={{
        title: t('pointcloud.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('pointcloud.settings.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    >
      {toolIcon}
    </WrapWithSettingsIcon>
  );
};

export { PointCloudTool };
